import React from 'react';

// Options:
// {
//   weekday: "short", // "narrow", "short", "long"
//   year: "numeric", // "2-digit", "numeric"
//   month: "2-digit", // "2-digit", "numeric", "narrow", "short", "long"
//   day: "2-digit", // "2-digit", "numeric"
//   hour: "2-digit", // "2-digit", "numeric"
//   minute: "2-digit", // "2-digit", "numeric"
// }

export const DateTimeFormat = ({
  date,
  options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  },
}) => {
  const formattedDateTime = new Date(date).toLocaleString(
    localStorage.locale || "nl-NL",
    options
  );
  return <span style={{whiteSpace: 'nowrap'}}>{formattedDateTime}</span>;
};
